import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Button,
    Label,
    Spinner
} from "reactstrap";
import featuresService from '../../services/api/features-service';
// Context
import ProjectContext from '../../ProjectContext';

// Components
import GrievanceListing from './GrievanceListing'; 
import '../connectedtv/ctv.css'; 


const GrievanceDashboard = (props) => {
    const history = useHistory();
    const projectDetails = useContext(ProjectContext);
    
    const [showLoader, setShowLoader] = useState(true);
    const [isGrievanceEnabled, setIsGrievanceEnabled] = useState(false);

    const projectId = projectDetails ? projectDetails.id : '';

    useEffect(() => {
        (async () => {
            if (projectId) {
                try {
                    const featureStatus = await featuresService.getFeatureStatus('enable_grievance_management', projectId);
                    console.log("featureStatus: ", featureStatus);
                    
                    if (featureStatus.status && featureStatus.data) {
                        setIsGrievanceEnabled(featureStatus.data.enable_grievance_management);
                    }
                } catch (error) {
                    console.log("Error fetching feature status:", error);
                } finally {
                    setShowLoader(false);
                }
            } else {
                 // If no project ID, stop loading anyway so we don't get stuck
                 setShowLoader(false);
            }
        })();
    }, [projectId]);

    if (!projectDetails || projectDetails.id === '') {
        history.push("/project/allprojects");
    }

    let getProjectSlug = new URLSearchParams(props.location.search).get('project');
    if (!getProjectSlug) {
        history.push({
            search: '?project=' + projectDetails.slug
        })
    }

    // --- DELETED DUPLICATE useEffect HERE ---

    // 4. Render
    if (showLoader) {
        return (
            <div className="container mt-30 text-center">
                <Spinner color="primary" />
            </div>
        );
    }

    if (isGrievanceEnabled) {
        return <GrievanceListing {...props} />;
    } else {
        return (
            <div className="container mt-30">
                <Card>
                    <CardHeader>
                        <Row>
                            <Col>
                                <Label className="ctvHeading"><b>Contact Us: helpdesk@sortd.mobi</b></Label>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <div className="ctvInfo">
                            <Row>
                                <Col>
                                    <h2>Sortd Grievance Management</h2>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="7">
                                    Now Manage, track, and resolve public grievances through one single platform.
                                </Col>
                            </Row>
                            <Row>
                                <Col md="7">
                                    Book a Demo now.
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button
                                        type="button"
                                        className="btnBlue btn btn-secondary"
                                        onClick={(event) => {
                                            window.open('https://mail.google.com/mail/?view=cm&fs=1&to=helpdesk@sortd.mobi&su=Enquiry for Sortd Grievance Management', '_blank');
                                            event.preventDefault();
                                        }}
                                    >
                                        Book Now
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default GrievanceDashboard;